import axios from 'axios';
import { REDIRECT_TO } from '../../web/businesslogic/preloginscreens/constants';
import General from '../utility/General';
import UrlEncodeDecode from '../txsearchparams/urlEncodeDecode';

const handleResponse = (navigateCb, dispatchNotificationCb, dispatchSetIsUserAuthenticatedCb, showSessionErrorCb) => {
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (axios.isCancel(error)) {
                return Promise.reject(error);
            }

            console.log(error);
            if (error.response && error.response.status === 401) {
                let  hashPath = window?.location?.hash

                const encodedParams = General.convertQueryStringToObj(hashPath)
                const decodedParamsString = encodedParams?.state ? UrlEncodeDecode.decode(encodedParams.state) : null

                let location = hashPath?.split("#")
                location = location?.length >= 2 ? location[1] : null

                if(decodedParamsString){
                    const urlPath =  location.split("?")[0]
                    location = `${urlPath}?${decodedParamsString}`
                }
                
                if (location?.length && (location == "/signin" || location.startsWith("/signin"))) {
                    return {
                        data: {
                            Status: 0,
                            Message: "",
                        }
                    };
                }
                
                let encodedLocation = General.encodeString(location)
                dispatchSetIsUserAuthenticatedCb(false);
                showSessionErrorCb();
                if(encodedLocation){
                    navigateCb(`/signin?${REDIRECT_TO}=${encodedLocation}`);
                } else{
                    navigateCb("/signin");
                }
                return {
                    data: {
                        Status: 0,
                        Message: "",
                    }
                }
            }else if(error.response && error.response.status === 400){
                return error.response;
            }
            else{
                throw error;
            }
        }
    );
};

export default handleResponse;